export class ConnectionDetails {
  public AuthType: string;
  public EndpointURL: string;
  public RequestXML: string;
  public UserName: string;
  public Password: string;
  public ClientID: string;
  public ClientSecret: string;
  public AuthURL: string;

  constructor(
    AuthType: string = '',
    EndpointURL: string = '',
    RequestXML: string = '',
    UserName: string = '',
    Password: string = '',
    ClientID: string = '',
    ClientSecret: string = '',
    AuthURL: string = ''
  ) {
    this.AuthType = AuthType;
    this.EndpointURL = EndpointURL;
    this.RequestXML = RequestXML;
    this.UserName = UserName;
    this.Password = Password;
    this.ClientID = ClientID;
    this.ClientSecret = ClientSecret;
    this.AuthURL = AuthURL;
  }
}
